import React, { useMemo } from 'react';
import { Stack } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';

export default function BlogLayout() {
  const { colors } = useTheme();

  const screenOptions = useMemo(() => ({
    headerShown: false,
    contentStyle: { backgroundColor: colors.solid_color_primary },
    animation: 'fade',
  }), [colors]);

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen name="index" />
      <Stack.Screen name="category/[slug]" />
      <Stack.Screen name="[slug]" />
    </Stack>
  );
}
